export default {
    previewInvoiceCollections: [],
    pendingInvoiceCollections: [],
    invoiceCollectionHistory: [],
    html: '',
    checksums: null,
    rejections: []
};
